import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../i18n";
import api, { mediaUrl } from "../lib/api";
import { Reveal } from "../components/motion";
import ShareButtons from "../components/ShareButtons";

const BlogPost = () => {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setPost(false));
  }, [slug]);

  if (post === null) return <div className="pt-40 pb-28 text-center text-foreground/50">…</div>;
  if (post === false) return <div className="pt-40 pb-28 text-center text-foreground/50">404</div>;

  const info = post[lang];

  return (
    <article data-testid="blogpost-page" className="pt-36 pb-28 max-w-3xl mx-auto px-6">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors mb-10">
        <ArrowLeft className="w-4 h-4" /> {t("blog.back")}
      </Link>
      <Reveal>
        <div className="flex items-center gap-3 text-xs text-foreground/50 mb-5 uppercase tracking-wider">
          <span className="text-primary">{post.category[lang]}</span><span>·</span><span>{post.date}</span><span>·</span><span>{post.read}</span>
        </div>
        <h1 className="font-serif text-4xl md:text-6xl tracking-tightest text-foreground leading-[1.03] mb-8">{info.title}</h1>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="h-[420px] overflow-hidden mb-12">
          <img src={mediaUrl(post.image)} alt="" className="w-full h-full object-cover" />
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="prose-lg space-y-6">
          {info.body.split("\n\n").map((para, i) => (
            <p key={i} className="text-lg text-foreground/75 leading-relaxed font-light">{para}</p>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-14 pt-8 border-t border-border">
          <ShareButtons url={window.location.href} title={`${info.title} · Nordicvy`} image={mediaUrl(post.image)} />
        </div>
      </Reveal>
    </article>
  );
};

export default BlogPost;
